<template>
  <section :id="`comp_id_${compProps.elementId}`" data-growing-container :key="keyName">
    <component :is="compName" :compProps="houses" :compId="(compProps.elementId+'')" @action="actionHandle"></component>
    <component :is="servCompName" :compProps="houstList" :payLoad="payLoad" :compIndex="compIndex" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
import HouseCard from '@/components/HouseCard'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'
import { getExclusiveHouse } from '@/utils'

export default {
  mixins: [mixin],
  data() {
    return {
      payLoad: null,
      houses: {}
    }
  },
  components: {
    HouseCard,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    compName() {
      return 'HouseCard'
    },
    houstList() {
      // 这是一个临时方案，哈哈哈哈，超级愚蠢的
      const houseList = this.$root.tmpHouseList
      let houses = []
      if (this.compProps.mate.privateProps.houseChoice === '3') {
        // 专属房源
        const { exclusiveHouse = '' } = this.$route.query
        // getExclusiveHouse是为了适配 query 参数上存在多房源的情况
        houses = exclusiveHouse ? getExclusiveHouse(exclusiveHouse).map((item) => {
          return { id: item }
        }) : []
      } else if (houseList) {
        // 房屋组
        const houseGroup = this.compProps.mate.items
        const tmpHouse = houseList[houseGroup]
        if (tmpHouse) {
          houses = tmpHouse
        } else {
          houses = []
        }
      }
      return {
        // houseChoice: this.compProps.mate.privateProps.houseChoice,
        // pageIndex: this.compProps.mate.privateProps.pageIndex,
        // landlordIds: this.compProps.mate.privateProps.landlordIds,
        // maxShowNumber: this.compProps.mate.privateProps.maxShowNumber,
        // promotionId: this.compProps.mate.privateProps.promotionId,
        // priceTime: this.compProps.mate.privateProps.priceTime,
        // needNoRepositoty: this.compProps.mate.privateProps.needNoRepositoty,
        // isJumpApp: this.compProps.mate.privateProps.isJumpApp,
        // isOutOfOrder: this.compProps.mate.privateProps.isOutOfOrder
        ...this.compProps.mate.privateProps,
        mode: this.compProps.mate.mode + '',
        elementId: this.compProps.elementId,
        houses
      }
    },
    keyName() {
      return this.$root.promotionId + this.compProps.elementId + ''
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payLoad) {
      // 一口价活动风险问题特殊处理
      const { id } = this.$route.query
      const ids = ['T20231023180727', 'Q20231026175936']
      const data = { ...payLoad }
      if (ids.indexOf(id) > -1) {
        // 获得档位
        const arr = (this.compProps.mate.items || '').match(/\d+/g)
        if (arr && arr[0]) {
          data.items = data.items.filter((item) => `${item.finalPrice}` === `${arr[0]}`)
          data.totalCount = data.items.length
        }
      }
      // TOC-4583 一口价换活动页特殊处理
      if (['Q20231208162248', 'T20231206152203', 'Q20231208192429'].indexOf(id) > -1) {
        // 只保留这几个价格档位的房屋
        const pd = ['99', '149', '199', '249', '299']
        data.items = data.items.filter((item) => pd.indexOf(`${item.finalPrice}`) > -1)
        data.totalCount = data.items.length
      }
      this.houses = {
        privateProps: this.compProps.mate.privateProps,
        mode: this.compProps.mate.mode + '',
        items: data.items,
        totalCount: data.totalCount
      }
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payLoad) {
      if (!this.$root.isPreview) {
        this.payLoad = payLoad
      }
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
      this.payLoad = null
      if (payLoad.type === 'favirote') {
        const index = this.houses.items.findIndex((item) => {
          return item.unitId === payLoad.data.id
        })
        this.houses.items[index].isLike = payLoad.data.isLike
      }
    }
  }
}
</script>
